import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={18.285}
    height="6.9mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16159 23047"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:334.013}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974344656496">
        <path
          d="M8136 167c8170 0 10595 9832 4283 14573-478 360-974 732-1237 1290-156 330-154 757-154 1116H5200c0-482 25-762-210-1212-267-514-719-873-1198-1254-2120-1687-3621-3745-3625-6556-7-4414 3541-7957 7969-7957zm1736 15625c513-1223 656-1264 1636-2021 1467-1138 3398-3002 3230-6044-194-3504-3110-6233-6616-6233-54 0-107 1-160 2-3426 83-6201 2771-6429 6182-172 2557 1053 4262 2908 5783 764 627 1550 1272 1965 2331h3466zM6137 20975h4047c83 0 151 65 152 148 9 433-140 819-433 1118-398 406-1039 639-1759 639-740 0-1411-252-1797-674-274-299-399-677-361-1093 7-79 72-138 151-138zM5720 18167l4738-428c252-23 470 165 484 419 14 253-181 479-434 502l-4738 428c-252 23-470-166-484-419-13-254 182-479 434-502zM5878 19768l4425-424c252-24 469 164 482 417s-183 480-435 504l-4424 424c-252 24-470-163-482-417-13-253 182-480 434-504z"
          className="fil0"
        />
        <path
          d="M5852 9182c-206 206-206 542 0 748l1810 1810c-2 16-2 32-2 48v2777c0 290 237 528 528 528s528-238 528-528v-2777c0-16 0-32-2-48l1810-1810c206-206 206-542 0-748-205-205-541-205-747 0l-1589 1589-1589-1589c-206-205-542-205-747 0z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
